export const ERRORS = {
  couldNotUpdateIssueBody: 'Could not update issue body',
  couldNotUpdateIssueBodyStale: 'The content you are editing has changed. Please copy your edits and refresh the page.',
}
